import { create } from "zustand";

export interface DialogOption {
    optionNameTranslationKey: string;
    optionFunction: () => void;
    optionColor?: string;
}

interface DialogPosition {
    x: number;
    y: number;
}

interface DialogState {
    isOpen: boolean;
    position: DialogPosition;
    titleTranslationKey: string;
    textTranslationKey: string;
    options: DialogOption[];

    showDialog: (
        position: DialogPosition,
        titleTranslationKey: string,
        textTranslationKey: string,
        options: DialogOption[]
    ) => void;
    hideDialog: () => void;
}

export const useDialogStore = create<DialogState>()((set) => ({
    isOpen: false,
    position: { x: 0, y: 0 },
    titleTranslationKey: "",
    textTranslationKey: "",
    options: [],

    showDialog: (position, titleTranslationKey, textTranslationKey, options) =>
        set({ isOpen: true, position, titleTranslationKey, textTranslationKey, options }),

    hideDialog: () =>
        set({ isOpen: false, options: [] }),
}));
